var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconMarketplace64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19923)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5953 21.1953V49.3784H13.3984V21.0029",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5953 21.1953V49.3784H13.3984V21.0029",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9374 36.48H30.8755V49.3783H35.9374V36.48Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3914 36.48H19.2749V42.436H25.3914V36.48Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2362 36.48H35.937V49.3783H45.2362V36.48Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 21.0063H17.6V25.2345C17.6 27.8859 15.451 30.0352 12.8 30.0352C10.149 30.0352 8 27.8859 8 25.2345V21.0063Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6001 21.0063H27.2001V25.2345C27.2001 27.8859 25.0511 30.0352 22.4001 30.0352C19.7491 30.0352 17.6001 27.8859 17.6001 25.2345V21.0063Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2002 21.0063H36.8002V25.2345C36.8002 27.8859 34.6511 30.0352 32.0002 30.0352C29.3492 30.0352 27.2002 27.8859 27.2002 25.2345V21.0063Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7998 21.0063H46.3998V25.2345C46.3998 27.8859 44.2508 30.0352 41.5998 30.0352C38.9488 30.0352 36.7998 27.8859 36.7998 25.2345V21.0063Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3999 21.0063H55.9999V25.2345C55.9999 27.8859 53.8509 30.0352 51.1999 30.0352C48.5489 30.0352 46.3999 27.8859 46.3999 25.2345V21.0063Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7177 15.6274H49.276C50.0046 15.6274 50.5953 16.2182 50.5953 16.9469V21.0018H13.3984V16.9469C13.3984 16.2182 13.9891 15.6274 14.7177 15.6274Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconMarketplace64);
export default __webpack_public_path__ + "static/media/pictogramBeaconMarketplace64.c1281dac0f5999326e4ef8cb6adaac00.svg";
export { ForwardRef as ReactComponent };